import { deprecatedAliasList } from '../deprecatedAliasList';
/**
 * Tries to return an alias for a deprecated variant and returns that instead.
 * Otherwise, the original name will be returned.
 */
export const getSupportedVariantName = (name) => {
    const alias = deprecatedAliasList.find(([deprecatedName]) => deprecatedName === name);
    if (alias) {
        const [, aliasedName] = alias;
        if (process.env.NODE_ENV === 'development') {
            console.warn(`DEPRECATION WARNING: Typography variant "${name}" has been aliased to "${aliasedName}". Please replace this with a supported variant.`);
        }
        return aliasedName;
    }
    return name;
};
